import React from 'react';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import { useLanguage } from '../LanguageContext';
import { TeamAvatarVisual } from '../components/visuals/DashboardVisuals';
import anuragPhoto from '../assets/anurag.jpg';
import ishaanPhoto from '../assets/ishaan.jpg';
import aayushPhoto from '../assets/aayush.jpg';
import ghanshyamPhoto from '../assets/ghanshyam.jpg';
import '../V3.css';

const TEAM_PHOTOS = {
  anurag: anuragPhoto,
  ishaan: ishaanPhoto,
  aayush: aayushPhoto,
  ghanshyam: ghanshyamPhoto,
};

const V3About = () => {
  const { t } = useLanguage();
  const team = t('about.team');

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header activeNav="about" />
        <div className="v3-hero">
          <h1>{t('about.title')}</h1>
        </div>

        <section className="v3-block">
          <h2>{t('about.teamTitle')}</h2>
          <div className="v3-grid2">
            {Array.isArray(team) && team.map(({ name, role, linkedin }) => {
              const photo = TEAM_PHOTOS[name.toLowerCase()];
              return (
                <div key={name} className="v3-wire-block v3-team-card">
                  {photo ? (
                    <img src={photo} alt={name} className="v3-team-photo" />
                  ) : (
                    <TeamAvatarVisual name={name} />
                  )}
                  <strong>{name}</strong>
                  <p style={{ fontSize: 13, color: '#333' }}>{role}</p>
                  {linkedin && (
                    <a href={linkedin} target="_blank" rel="noopener noreferrer" className="v3-team-link">
                      LinkedIn →
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </section>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3About;
